export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/pets/index/resources/computed.js